<template>
    <!-- 商圈資訊頁內層 -->
    <div class="info-block">
        <nav class="sub-tab top-button-show">
            <a :class="{active: activeTab === 'intro'}" @click="typeChanged('intro')">介紹</a>
            <a :class="{active: activeTab === 'brand'}" @click="typeChanged('brand')" v-show="shopStoreList.length > 0">在地精選</a>
            <a :class="{active: activeTab === 'map'}" @click="typeChanged('map')" v-show="isShowMap(shoppingAreaMap)">地圖</a>
        </nav>
        <IntroInfo v-show="activeTab==='intro'" :outerAreaInfo="outerAreaInfo"/>
        <Brand v-show="activeTab==='brand'" :key="componentKey" @checkShopStoreList="checkShopStoreList"/>
        <Map v-show="activeTab==='map'" :outerAreaMap="shoppingAreaMap"/>
    </div>
</template>

<script>
    import Brand from './components/Brand';
    import Map from './components/Map';
    import IntroInfo from "./components/IntroInfo";
    export default {
        name: "MarketplaceInfo",
        components: {
            IntroInfo,
            Brand,
            Map,
        },
        props: {
            outerAreaInfo: { default: undefined },  // 外層傳來的 shoppingAreaInfo
            outerActInfo: { default: undefined },  // 外層傳來的 shoppingActInfo
        },
        watch: {
            //監聽，等到資料有變動再開始動作
            outerAreaInfo: function() {
                if (this.outerAreaInfo !== undefined) {

                    let self = this;
                    self.componentKey += 1;
                    //取得地圖
                    self.getShoppingAreaMap()
                        .catch((error) => {
                            console.log(`loading error: ${error}`);
                        });
                }
            },

            //監聽，等到資料有變動再開始動作
            outerActInfo: function() {

            },
        },
        data() {
            return {
                //分頁
                activeTab: 'intro',
                shopAreaId: Number(this.$store.state.shopAreaInfo.id),   //商圈 id
                shoppingAreaMap: {},        //地圖
                componentKey: 0,

                shopStoreList: [],
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            typeChanged(activeTab) {
                if (this.$public.notNull(this.$store.state.shopAreaInfo.id)) {
                    //避免重複 replace產生錯誤
                    if (this.$public.notNull(this.$route.query.activeTab) && (this.$route.query.activeTab !== activeTab)) {
                        this.$router.replace({ name: this.$route.name, query: { activeTab: activeTab, shopAreaId: this.shopAreaId }});
                    }
                } else {
                    // this.$router.push({ name: this.$route.name, query: { activeTab: activeTab, shopAreaId: this.shopAreaId }});
                    this.$router.replace({ name: this.$route.name, query: { activeTab: activeTab }});
                }

                if (activeTab === 'brand') {
                    this.msg = 'aa';
                }

                // this.$router.replace({ name: this.$route.name, query: { activeTab: activeTab }});
                this.activeTab = activeTab
                this.$emit("activeTab", this.activeTab)
            },

            /** 取得商圈地圖 */
            getShoppingAreaMap: function () {
                // let pData = this.pageData;
                let self = this;
                return new Promise(function(resolve, reject) {
                    //夜市商圈列表
                    self.$http.fetch`GetShoppingAreaMap${{
                        shopAreaId: Number(self.$store.state.shopAreaInfo.id),
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.shoppingAreaMap = json.data;
                            //完畢
                            resolve();

                        } else {
                            reject("無法讀取商圈地圖");
                        }
                    }}`;
                });
            },

            /** 是否顯示店家列表頁籤 */
            isShowBrand: function(item) {
                return (this.$public.notNull(item)) ;
            },

            /** 是否顯示地圖 */
            isShowMap: function(item) {
                return (this.$public.notNull(item) &&
                    (this.$public.notNull(item.mapImageUrl) && item.mapImageUrl !== '') ||
                    (this.$public.notNull(item.geographicNote) && item.geographicNote !== '') ||
                    (this.$public.notNull(item.googleMapUrl) && item.googleMapUrl !== '')) ;
            },

            checkShopStoreList: function (item) {
                this.shopStoreList = item;
            },

        }
    }
</script>
